"use strict";
require("./js/angular.filteroffice.js");
require("./js/angular.registration.js");
require("./js/ui.js");



/*****************
 ** WEBPACK FOOTER
 ** ./assets_src/index.js
 ** module id = 0
 ** module chunks = 0
 **/